// import React, { useContext, useState } from "react";
// import { useNavigate, Link } from "react-router-dom";
// import axios from "axios";

// import data from "../language.json";
// import languageContext from "../context/language/languageContext";

// const Signup = () => {
//   const navigate = useNavigate();

//   const { lang, phone, setPhone } = useContext(languageContext);

//   const [name, setName] = useState("");
//   const [acceptedTerms, setAcceptedTerms] = useState(false);
//   const [loader, setLoader] = useState(false);
//   const [responseMessage, setResponseMessage] = useState("");

//   // DOB → AGE
// const calculateAge = (dob) => {
//   const birthDate = new Date(dob);
//   const today = new Date();

//   let age = today.getFullYear() - birthDate.getFullYear();
//   const m = today.getMonth() - birthDate.getMonth();

//   if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
//     age--;
//   }

//   return age;
// };

// // AGE → DOB
// const calculateDOB = (age) => {
//   const today = new Date();
//   const year = today.getFullYear() - age;
//   return `${year}-01-01`;
// };

//   /* ---------------- SIGNUP HANDLER ---------------- */
//   const handleSignup = async (e) => {
//     e.preventDefault();

//     if (!name.trim()) {
//       setResponseMessage("Please enter your name.");
//       return;
//     }

//     if (phone.length !== 10 || isNaN(phone)) {
//       setResponseMessage("Please enter a valid 10-digit number.");
//       return;
//     }

//     if (!acceptedTerms) {
//       setResponseMessage("Please accept the Terms & Conditions to proceed.");
//       return;
//     }

//     try {
//       setLoader(true);

//       const response = await axios.post(
//         `${API_URL}/sigup_send_otp",
//         JSON.stringify({ phone, name }),
//         {
//           headers: {
//             Accept: "*/*",
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       setResponseMessage(response.data.msg || "OTP sent successfully.");
//       navigate("/otp", { state: { from: "signup", name } });
//     } catch (error) {
//       console.error(error);
//       setResponseMessage("Cannot Signup. Please try again.");
//     } finally {
//       setLoader(false);
//     }
//   };

//   /* ---------------- UI ---------------- */
//   return (
//     <div className="bg-gradient-to-br from-teal-500 via-green-400 to-blue-300 min-h-screen flex justify-center items-center relative overflow-hidden">
//       {/* Main Card */}
//       <div className="w-full max-w-md bg-white rounded-lg shadow-xl px-8 py-10 relative z-10 animate-fadeIn">
//         {/* Progress Indicator */}
//         <div className="flex justify-center space-x-3 mb-8">
//           <div className="bg-teal-500 w-4 h-4 rounded-full"></div>
//           <div className="bg-gray-300 w-4 h-4 rounded-full"></div>
//           <div className="bg-gray-300 w-4 h-4 rounded-full"></div>
//         </div>

//         {/* Heading */}
//         <h1 className="text-3xl sm:text-4xl text-teal-600 font-bold mb-3">
//           {data[lang]["auth"][0]}
//         </h1>
//         <p className="text-gray-600 mb-6">
//           Enter your details to get started
//         </p>

//         {/* Form */}
//         <form
//           onSubmit={handleSignup}
//           className="flex flex-col items-center space-y-4"
//         >
//           {/* Name */}
//           <input
//             type="text"
//             required
//             maxLength="50"
//             placeholder="Enter your full name"
//             value={name}
//             onChange={(e) => setName(e.target.value)}
//             className="w-full px-4 py-2 rounded-lg bg-gray-100 border border-gray-300 text-center text-gray-800 focus:outline-none focus:ring-2 focus:ring-teal-500 transition-all duration-300 hover:scale-105"
//           />

//           {/* Phone */}
//           <input
//             type="text"
//             required
//             maxLength="10"
//             pattern="[0-9]{10}"
//             placeholder="Enter 10-digit mobile number"
//             value={phone}
//             onChange={(e) => setPhone(e.target.value)}
//             className="w-full px-4 py-2 rounded-lg bg-gray-100 border border-gray-300 text-center text-gray-800 focus:outline-none focus:ring-2 focus:ring-teal-500 transition-all duration-300 hover:scale-105"
//           />

//           {/* Terms */}
//           <div className="w-full flex items-start space-x-2 text-sm text-gray-700">
//             <input
//               type="checkbox"
//               id="terms"
//               checked={acceptedTerms}
//               onChange={(e) => setAcceptedTerms(e.target.checked)}
//               className="mt-1 accent-teal-600 cursor-pointer"
//             />
//             <label htmlFor="terms" className="cursor-pointer">
//               I agree to the{" "}
//               <Link
//                 to="/terms"
//                 target="_blank"
//                 className="text-teal-600 font-medium hover:underline"
//               >
//                 Terms & Conditions
//               </Link>{" "}
//               and{" "}
//               <Link
//                 to="/privacy"
//                 target="_blank"
//                 className="text-teal-600 font-medium hover:underline"
//               >
//                 Privacy Policy
//               </Link>
//             </label>
//           </div>

//           {/* Submit */}
//           <button
//             type="submit"
//             disabled={loader || !acceptedTerms || !name.trim()}
//             className={`w-full bg-teal-600 text-white py-2 px-4 rounded-lg font-semibold transition-all duration-300 ${
//               loader || !acceptedTerms || !name.trim()
//                 ? "opacity-60 cursor-not-allowed"
//                 : "hover:bg-teal-700 transform hover:scale-105"
//             }`}
//           >
//             {loader ? (
//               <div className="w-5 h-5 border-2 border-t-white border-b-white border-l-transparent border-r-transparent animate-spin rounded-full mx-auto"></div>
//             ) : (
//               "Proceed"
//             )}
//           </button>
//         </form>

//         {/* Message */}
//         {responseMessage && (
//           <div
//             className={`mt-4 text-sm font-medium ${
//               responseMessage.includes("success")
//                 ? "text-green-600"
//                 : "text-red-500"
//             }`}
//           >
//             {responseMessage}
//           </div>
//         )}

//         {/* Login */}
//         <div className="mt-6 text-gray-700 text-sm">
//           Already have an account?{" "}
//           <Link to="/login" className="text-teal-500 hover:underline">
//             Login Here
//           </Link>
//         </div>
//       </div>

//       {/* Background Shapes */}
//       <div className="absolute w-[450px] h-[450px] bg-green-300 opacity-40 rounded-full top-10 left-10 animate-pulse"></div>
//       <div className="absolute w-[350px] h-[350px] bg-teal-300 opacity-30 rounded-full bottom-10 right-10 animate-pulse"></div>
//     </div>
//   );
// };

// export default Signup;

import React, { useContext, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";

import data from "../language.json";
import languageContext from "../context/language/languageContext";
import {API_URL,FAST_API_URL } from "../api"
const Signup = () => {
  const navigate = useNavigate();
  const { lang, setPhone } = useContext(languageContext);

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    age: "",
    date_of_birth: "",
    abha_id: "",
  });

  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [loader, setLoader] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");

  /* ---------------- AGE ↔ DOB LOGIC ---------------- */

  const calculateAge = (dob) => {
    const birthDate = new Date(dob);
    const today = new Date();

    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();

    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }

    return age;
  };

  const calculateDOB = (age) => {
    const today = new Date();
    const year = today.getFullYear() - age;
    return `${year}-01-01`;
  };

  /* ---------------- HANDLE CHANGE ---------------- */

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "age") {
      setFormData((prev) => ({
        ...prev,
        age: value,
        date_of_birth: calculateDOB(value),
      }));
    } 
    else if (name === "date_of_birth") {
      setFormData((prev) => ({
        ...prev,
        date_of_birth: value,
        age: calculateAge(value),
      }));
    } 
    else if (name === "abha_id") {
      // allow only numbers and dash
      if (!/^[0-9-]*$/.test(value)) return;

      setFormData((prev) => ({
        ...prev,
        abha_id: value,
      }));
    } 
    else if (name === "phone") {
    // Optional: allow only digits
    if (!/^\d*$/.test(value)) return;

    // Update formData
    setFormData((prev) => ({
      ...prev,
      phone: value,
    }));

    // Update context
    setPhone(value);
  } 
    else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  /* ---------------- SIGNUP HANDLER ---------------- */

  const handleSignup = async (e) => {
    e.preventDefault();

    if (!formData.name.trim()) {
      setResponseMessage("Please enter your name.");
      return;
    }

    if (formData.phone.length !== 10 || isNaN(formData.phone)) {
      setResponseMessage("Please enter a valid 10-digit number.");
      return;
    }

    if (!acceptedTerms) {
      setResponseMessage("Please accept the Terms & Conditions.");
      return;
    }

    try {
      setLoader(true);
  

      const payload = {
        ...formData,
        date_of_birth: formData.date_of_birth
          ? new Date(formData.date_of_birth).toLocaleDateString("en-GB")
          : "",
      };

      const response = await axios.post(
        `${API_URL}/sigup_send_otp`,
        JSON.stringify(payload),
        {
          headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
          },
        }
      );

      setResponseMessage(response.data.msg || "OTP sent successfully.");
      navigate("/otp", { state: { from: "signup", name: formData.name } });

    } catch (error) {
      console.error(error);
      setResponseMessage("Cannot Signup. Please try again.");
    } finally {
      setLoader(false);
    }
  };

  /* ---------------- UI ---------------- */

  return (
    <div className="bg-gradient-to-br from-teal-500 via-green-400 to-blue-300 min-h-screen flex justify-center items-center">
      <div className="w-full max-w-md bg-white rounded-lg shadow-xl px-8 py-10">

        <h1 className="text-3xl text-teal-600 font-bold mb-3">
          {data[lang]["auth"][0]}
        </h1>

        <p className="text-gray-600 mb-6">
          Enter your details to get started
        </p>

        <form
          onSubmit={handleSignup}
          className="flex flex-col space-y-4"
        >

          {/* NAME */}
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Enter full name"
            className="w-full px-4 py-2 rounded-lg bg-gray-100 border"
          />

          {/* PHONE */}
          <input
            type="text"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            placeholder="Enter 10-digit mobile number"
            className="w-full px-4 py-2 rounded-lg bg-gray-100 border"
          />

          {/* AGE + DOB */}
          <div className="grid grid-cols-2 gap-3">
            <input
              type="number"
              name="age"
              value={formData.age}
              onChange={handleChange}
              placeholder="Age"
              className="px-4 py-2 rounded-lg bg-gray-100 border"
            />

            <input
              type="date"
              name="date_of_birth"
              value={formData.date_of_birth}
              onChange={handleChange}
              className="px-4 py-2 rounded-lg bg-gray-100 border"
            />
          </div>

          {/* ABHA ID */}
          <input
            type="text"
            name="abha_id"
            value={formData.abha_id}
            onChange={handleChange}
            placeholder="Enter ABHA ID"
            className="w-full px-4 py-2 rounded-lg bg-gray-100 border"
          />

          {/* TERMS */}
          <div className="flex items-start space-x-2 text-sm">
            <input
              type="checkbox"
              checked={acceptedTerms}
              onChange={(e) => setAcceptedTerms(e.target.checked)}
            />
            <label>
              I agree to the{" "}
              <Link to="/terms" className="text-teal-600">Terms</Link> and{" "}
              <Link to="/privacy" className="text-teal-600">Privacy</Link>
            </label>
          </div>

          {/* BUTTON */}
          <button
            type="submit"
            disabled={loader}
            className="bg-teal-600 text-white py-2 rounded-lg"
          >
            {loader ? "Processing..." : "Proceed"}
          </button>

        </form>

        {/* MESSAGE */}
        {responseMessage && (
          <p className="mt-4 text-sm text-red-500">
            {responseMessage}
          </p>
        )}

      </div>
    </div>
  );
};

export default Signup;